import { createContext, useContext } from 'react';
/**
 * TODO: Add jsdoc
 */
export var SplitButtonContext = /*#__PURE__*/createContext(undefined);
export var useSplitButtonContext = function useSplitButtonContext() {
  var context = useContext(SplitButtonContext);
  if (!context) {
    return undefined;
  }
  if (context.appearance === 'navigation') {
    var newContext = {
      spacing: 'default',
      appearance: 'subtle',
      isDisabled: false,
      isActiveOverSelected: false,
      isNavigationSplitButton: true,
      isHighlighted: context.isHighlighted
    };
    return newContext;
  }
  var splitButtonContext = {
    spacing: context.spacing,
    appearance: context.appearance,
    isDisabled: context.isDisabled,
    isActiveOverSelected: true,
    isNavigationSplitButton: false,
    isHighlighted: false
  };
  return splitButtonContext;
};